import _typeof from "@babel/runtime/helpers/esm/typeof";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
import { useQuery } from '@tanstack/react-query';
import makeQueryKey from "../../utils/make-query-key";
/**
 * Loads shop-components script from within the monorepo/dynamically if shouldUseDynamicImport is true
 * and calls initNikeShop with the provided params.
 * If not loading dynamically, you will need to add the script tag yourself.
 *
 * @param {boolean} params.shouldUseDynamicImport - Boolean to determine if dynamic import for shop-components should be used.
 * @param {Object} params.initNikeShopParams - Parameters to be passed to initNikeShop
 * @returns {UseQueryResult} - The result of the useQuery hook.
 */

var useInitNikeShop = function useInitNikeShop(_ref) {
  var shouldUseDynamicImport = _ref.shouldUseDynamicImport,
    initNikeShopParams = _ref.initNikeShopParams;
  var _useQuery = useQuery({
      queryKey: makeQueryKey(['dynamic-import-nike-shop']),
      queryFn: function queryFn() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@nike/shop-components/es/entry/client.js'));
        });
      },
      enabled: shouldUseDynamicImport
    }),
    isNikeShopDynamicImportSuccess = _useQuery.isSuccess;
  var shouldInitNikeShop = !shouldUseDynamicImport || shouldUseDynamicImport && isNikeShopDynamicImportSuccess;

  // eslint-disable-next-line @tanstack/query/exhaustive-deps
  return useQuery({
    enabled: shouldInitNikeShop,
    queryKey: makeQueryKey(['nike-shop-script']),
    queryFn: function queryFn() {
      return window.initNikeShop(initNikeShopParams);
    }
    // staleTime: 0,
    // cacheTime: 0,
  });
};
export default useInitNikeShop;